import Audiobook from "./audiobook.component";

export default Audiobook;
